module.exports = __webpack_public_path__ + "img/manufacture-sp.81935805.jpg";